<template>
  <div class="my-charge">
    <div v-if="chargeTF">
      <div class="charge-list" v-for="(year, index) in chargeList" :key="year.id">
        <div class="year-tag">
          <el-tag type="warning">{{year.year}}年度</el-tag>
        </div>
        <el-row class="card-list" v-for="list in year.data" :key="list.id">
          <div @click="goChargeDetail(list.ClientMstCode,year.year)">
            <el-col :span="3"><img src="../assets/history.png"/></el-col>
            <el-col :span="9" v-if="list.ClientMstCode.length>12"><span>{{list.ClientMstCode.substr(0,4) + "****" + list.ClientMstCode.substr(-4)}}</span>
            </el-col>
            <el-col :span="9" v-else><span>{{list.ClientMstCode}}</span></el-col>
            <el-col :span="5" :push="1"><p class="houseName">{{list.housingEstateName}}</p></el-col>
            <el-col :span="3" v-if="list.PaymentState === '1' && year.checkYear" :push="2">
              <el-tag class="go-charge-tag" @click="goCharge(list.ClientMstCode, year.year)">去缴费</el-tag>
            </el-col>
          </div>
        </el-row>
      </div>
    </div>
    <div v-else class="none">
      <img class="wushuju" src="../assets/wushuju.png" width="120" height="80"/><br/>
      <span>无缴费记录</span>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'

  export default {
    name: "myCharge",
    data() {
      return {
        userID: 2,
        // userID: this.$store.getters.getUserInfo.userID,
        openID: "o5vFewIMieT8e-ScGJBzmXVfmxNA",
        // openID: this.$store.getters.getUserInfo.openID,
        imageUrl: require("../assets/history.png"),
        chargeList: [],
        chargeTF: false,
      }
    },
    methods: {
      goCharge(cardNum, year) {
        this.$router.push({path: '/charge-detail', query: {yearTitle: year, butState: true, cardNum: cardNum}})
      },
      goChargeDetail(cardNum, year) {
        this.$router.push({path: '/charge-detail', query: {yearTitle: year, butState: false, cardNum: cardNum}})
      },
      getMyHeating() {
        let params = {
          userID: this.userID,
          openID: this.openID
        };
        this.$http.getMyHeating(params).then(res => {
          if (res.state === 1) {
            this.chargeList = res.data.dataList;
            if (res.data.dataList.length > 0) {
              this.chargeTF = true;
            }
          } else {
            Toast({
              message: res.msg,
              duration: 2000
            })
          }

        })
      }
    },
    mounted() {
      this.getMyHeating();
    }

  }
</script>

<style scoped>
  .img-his {
    width: 20px;
    height: 20px;
  }

  .none {
    text-align: center;
    color: gainsboro;
    margin-top: 30vh;
  }

  .charge-list {
    width: 100%;
    background-color: white;
    border-bottom: 10px solid #EBEEF5;
  }

  .year-tag {
    padding: 10px;
  }

  .card-list {
    margin: 10px;
    border-bottom: 1px solid #EBEEF5;
    padding-bottom: 7px;
    font-size: 14px;
  }

  .card-list img {
    width: 20px;
    height: 20px;
    /*margin-top: 10px;*/
  }

  .go-charge-tag {
    /*width: 50px;*/
    text-align: center;
    margin-top: -5px;
  }

  .houseName {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 70px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/myCharge.vue